import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { auth, firestore as db } from "../../FirebaseConfig";
import { doc, onSnapshot } from "firebase/firestore";
import Logo from "../assests/logo.png";
import AnnouncementCarousel from "../Announcement";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  

  const handleLogout = () => {
    signOut(auth).then(() => {
      setUser(null);
      setIsAccountDropdownOpen(false);
    });
  };
  const handleSearch = () => {
    if (searchQuery.trim()) {
      window.location.href = `/shop?search=${encodeURIComponent(searchQuery.trim())}`;
    }
  };
  

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchCartItemCount(currentUser.uid);
      }
    });

    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchCartItemCount = (userId) => {
    const cartRef = doc(db, "customers", userId);
    return onSnapshot(cartRef, (cartSnap) => {
      if (cartSnap.exists() && cartSnap.data().items) {
        const totalItems = cartSnap.data().items.reduce((sum, item) => sum + item.quantity, 0);
        setCartCount(totalItems);
      } else {
        setCartCount(0);
      }
    });
  };

  return (
    <>
      <AnnouncementCarousel />

      {/* Navigation Bar */}
      <nav className="bg-white shadow-md fixed top-7 left-0 w-full z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-20">




            {/* Mobile Menu Toggle (Only visible on Mobile) */}
            {isMobile && (
              <div className="flex ">

                <button
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  className="p-2 text-gray-600 hover:text-orange-500 transition-colors"
                >
                  {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
                <a style={{ left: "calc(45% - 90px)", top: 10 }}
                  href={user ? "/cart" : "/login"} className="absolute  hover:text-orange-500 transition-colors">
                  <img
                    src={cartCount > 0 ? "/assets/General/cart_open.png" : "/assets/General/cart_close.png"}
                    className="h-16 w-16"
                    alt="Cart"
                  />
                  {cartCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {cartCount}
                    </span>
                  )}
                </a>



              </div>

            )}

            {!isMobile && <a href={user ? "/cart" : "/login"} className="relative hover:text-orange-500 transition-colors">
              <img
                src={cartCount > 0 ? "/assets/General/cart_open.png" : "/assets/General/cart_close.png"}
                className="h-16 w-16"
                alt="Cart"
              />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </a>


            }
            {/* Left Section - Account Icon */}


            {/* Center Section - Product Links + Logo */}
            {!isMobile && (
              <div className="flex left-0 items-center space-x-2">
                <a href="/shop" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Products</a>
                <a href="/shop?category=beekeeping" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Bee Hives</a>
                <a href="/learn-beekeeping" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Beekeeping</a>
                <div className="w-30"> </div>
              </div>
            )}

            {/* Logo - Exactly Centered */}
            <div className="absolute left-1/2 transform -translate-x-1/2">
              <a href="/">
                <img src={Logo} className="h-18 w-auto" alt="Logo" />
              </a>
            </div>

            {/* Right Section - Recipes, Blog, Mission & Cart */}
            {!isMobile && (
              <div className="flex items-center space-x-6">
                <a href="/recipes" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Recipes</a>
                <a href="/blog" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Blog</a>
                <a href="/about" className="px-4 py-3 text-gray-700 font-semibold hover:text-orange-500">Mission</a>
                <div className="w-30"> </div>

                {/* Cart Icon */}

              </div>
            )}



<div className="relative">
  {/* <button
    onClick={() => setShowSearch(!showSearch)}
    className="text-gray-600 text-3xl hover:text-orange-500"
  >
    🔍
  </button> */}
  <button
               onClick={() => setShowSearch(!showSearch)}
                className="flex items-center  "
              >
                <img src="/assets/General/Search.png" className="h-8 w-8" alt="Search" />
              </button>

  {showSearch && (
    <div className="absolute right-0 mt-2 bg-white shadow-lg rounded-md flex items-center space-x-2 p-2 z-50">
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search products..."
        className="border px-3 py-1 rounded-md focus:outline-none"
      />
      <button
        onClick={handleSearch}
        className="bg-orange-500 text-white px-3 py-1 rounded-md hover:bg-orange-600"
      >
        Go
      </button>
    </div>
  )}
</div>



<div className="absolute items-center space-x-2 right-[calc(45%-90px)] bottom-[22px] md:right-[calc(15%-50px)]">
              <button
                onClick={() => {
                  if (user) {
                    setIsAccountDropdownOpen(!isAccountDropdownOpen);
                  } else {
                    window.location.href = "/login"; // Redirects to login page
                  }
                }}
                className="flex items-center  "
              >
                <img src="/assets/General/account_icon.png" className="h-10 w-10" alt="Account" />
              </button>
              {isAccountDropdownOpen && (
                <div className="absolute right-10  w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                  <div className="py-1">
                    <a href="/account" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      My Account
                    </a>
                    <a href="/orders" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      My Orders
                    </a>
                    <button
                      onClick={handleLogout}
                      className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    >
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>




          </div>
        </div>
      </nav>

      {/* Mobile Side Navigation */}
      {isMobileMenuOpen && (
        <div className="fixed inset-y-0 left-0 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50">
          <div className="flex flex-col h-full">
            {/* Close Button */}
            <div className="flex justify-between items-center p-4 border-b">
              <a href="/">
                <img src={Logo} className="h-10" alt="Logo" />
              </a>
              <button onClick={() => setIsMobileMenuOpen(false)}>
                <X className="h-6 w-6 text-gray-600 hover:text-orange-500" />
              </button>
            </div>

            {/* Mobile Menu Items */}
            <div className="p-2">
              <a href="/shop" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Products</a>
              <a href="/shop?category=beekeeping" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Bee Hives</a>
              <a href="/learn-beekeeping" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Beekeeping</a>
              <a href="/recipes" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Recipes</a>
              <a href="/blog" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Blog</a>
              <a href="/about" className="block py-2 text-gray-700 font-semibold hover:text-orange-500">Mission</a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
